import styled from "styled-components";

export const SupportContainer = styled.div`
  h2 {
    font-size: 14px;
    font-weight: 500;
    color: #181d27;
    font-family: "Geist", sans-serif;
  }
  margin: 0px 0 24px;
  border: 1px solid rgba(10, 13, 18, 0.1);
  border-radius: 16px;
  .support-cards {
    padding: 20px;
  }
  .support-heading {
    padding: 20px;
    border-bottom: 1px solid rgba(10, 13, 18, 0.1);
  }

  .support-card {
    background: #fafafa;
    border-radius: 16px;
    padding: 2rem;
    text-align: center;
    transition: all 0.3s ease;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }

    .icon-wrapper {
      margin-bottom: 1.5rem;

      svg {
        opacity: 0.7;
      }
    }

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #181d27;
      font-family: "Geist", sans-serif;
      margin-bottom: 8px;
    }

    p {
      font-size: 0.95rem;
      color: black;
      margin-bottom: 1.5rem;
      line-height: 1.5;
      flex-grow: 1;
    }

    button {
      background: #ffffff;
      border: 1px solid #d5d7da;
      color: #535862;
      font-family: "Geist", sans-serif;
    }
  }

  @media (max-width: 768px) {
    .support-cards {
      gap: 1rem;
    }

    .support-card {
      margin-bottom: 1rem;
    }
  }
`;
